export default {...window.AppMessages};